<div class="printheader">
  <div class="card">
    <div class="card-header border-bottom-0px text-align-center">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-1" *ngIf="hasimage==1">
            <img src="garbhagudilogo(small).png" class="user-image-circle-65px img2">
          </div>
          <div class="col-md-1" *ngIf="!hasimage">
           
          </div>
          <div class="col-md-6 padding-left-20px">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5">Bill No: HL2-HL-OB17003714</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Patient ID New/Old: HL2I/1151</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Age: 26</label>
            </div>
                        
          </div>
          <div class="col-md-5">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Bill Date: {{Date | date:'dd-MMM-yyyy'}}</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Patient Name: Mrs.SITADEVI</label>
            </div>

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px f5 font-weight-normal">Gende: Female</label>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      
    </div>

  </div>
</div>

